import * as React from 'react';
import * as styles from './styles.css';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { Header4, Header5 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import { optionsRenderers } from '../../utils/optionsRenderers';
import { TPreciseFilterStateChangeHandler } from '../../types';
import {
  IPreciseFilter,
  TPreciseFiltersState,
  EPreciseFilterValues,
  EExtendsOptions,
} from '../../../../types/redux/preciseFilters';
import { EType } from '../../../../repositories/price-estimator/entities/filter/FilterSchema';

interface IFiltersModalContentProps {
  preciseFilters: IPreciseFilter[];
  preciseFiltersState: TPreciseFiltersState;
  handleChange: TPreciseFilterStateChangeHandler;
  isDisabledFilters?: boolean;
}

export const FiltersModalContent: React.FC<IFiltersModalContentProps> = props => {
  const { preciseFilters, preciseFiltersState, handleChange, isDisabledFilters } = props;

  const isDesktop = useIsDesktop();

  return (
    <ul className={styles['container']} data-testid="precise_filters_all_filters">
      {preciseFilters.map(filterBlock => {
        const OptionsRenderer = optionsRenderers[filterBlock.type];
        const filterState = preciseFiltersState[filterBlock.name] || [];
        const options =
          /**
           * Для радио фильтра добавляем в начало списка опшинов пункт "Не выбрано" для сброса значения фильтра
           * Почему не на бэке? - бэк не знает про сброс, сброс фактически это "не отправляем поле, если оно не выбрано"
           */
          filterBlock.type === EType.RadioButton
            ? [{ displayName: 'Не выбрано', name: EExtendsOptions.Reset }, ...filterBlock.options]
            : filterBlock.options;

        const handleFilterChange = (filterValue: EPreciseFilterValues) => {
          handleChange({
            filterValue,
            prevState: preciseFiltersState,
            filterType: filterBlock.type,
            filterName: filterBlock.name,
          });
        };

        return (
          <li key={filterBlock.name} className={styles['filter']}>
            <div className={styles['filter_title']}>
              <ConditionalWrapper if={isDesktop} ThenComponent={Header5} ElseComponent={Header4}>
                {filterBlock.displayName}
              </ConditionalWrapper>
            </div>
            <OptionsRenderer
              options={options}
              onChange={handleFilterChange}
              filterName={filterBlock.name}
              disabled={isDisabledFilters}
              filterState={filterState}
            />
          </li>
        );
      })}
    </ul>
  );
};

FiltersModalContent.displayName = 'FiltersModalContent';
